<template>
  <a-drawer @close="close" :visible="addressModal" title="Select Deliverable Area" width="50%" class="modal" >
    <a-input-search
      v-model="searchValue"
      placeholder="Search area"
      allow-clear
      class="margin-bottom-sm"
    />
    <div class="acea-row row-right row-middle margin-bottom-sm">
      <a-checkbox v-model="iSselect" @change="allCheckbox">Select All</a-checkbox>
      <span class="empty padding-left-sm" @click="empty">Clear</span>
    </div>
    <a-tree
      ref="tree"
      :tree-data="filteredTreeData"
      :checked-keys="checkedKeys"
      :expanded-keys="expandedKeys"
      checkable
      block-node
      :selectable="false"
      @check="onCheck"
      @expand="onExpand"
      class="area-tree"
    />
    <div class="foot-btn">
      <a-button @click="close" class="margin-right-sm">Cancel</a-button>
      <a-button type="primary" @click="confirm">OK</a-button>
    </div>
  </a-drawer>
</template>

<script>
import * as logistics from '@/api/logistics'
import { mapGetters } from 'vuex'

// 洲展示顺序
const CONTINENT_ORDER = ['亚洲', '欧洲', '非洲', '北美洲', '南美洲', '其它']

// 国家 -> 洲 映射（同时支持中文 fullName 与英文/原名 areaName）
const COUNTRY_CONTINENT = {
  // 亚洲
  '中国': '亚洲', '日本': '亚洲', '韩国': '亚洲', '朝鲜': '亚洲', '蒙古': '亚洲', '越南': '亚洲', '泰国': '亚洲', '新加坡': '亚洲', '马来西亚': '亚洲', '印度尼西亚': '亚洲', '菲律宾': '亚洲', '印度': '亚洲', '巴基斯坦': '亚洲', '孟加拉国': '亚洲', '哈萨克斯坦': '亚洲', '土耳其': '亚洲', '沙特阿拉伯': '亚洲', '阿联酋': '亚洲', '以色列': '亚洲', '伊拉克': '亚洲', '伊朗': '亚洲', '柬埔寨': '亚洲', '缅甸': '亚洲', '老挝': '亚洲', '尼泊尔': '亚洲', '斯里兰卡': '亚洲', '卡塔尔': '亚洲', '科威特': '亚洲',
  'China': '亚洲', 'Japan': '亚洲', 'South Korea': '亚洲', 'Korea': '亚洲', 'Vietnam': '亚洲', 'Thailand': '亚洲', 'Singapore': '亚洲', 'Malaysia': '亚洲', 'Indonesia': '亚洲', 'Philippines': '亚洲', 'India': '亚洲', 'Pakistan': '亚洲', 'Turkey': '亚洲', 'Saudi Arabia': '亚洲', 'United Arab Emirates': '亚洲', 'Israel': '亚洲',
  '대한민국': '亚洲', 'ประเทศไทย': '亚洲',
  // 欧洲
  '法国': '欧洲', '英国': '欧洲', '德国': '欧洲', '意大利': '欧洲', '芬兰': '欧洲', '荷兰': '欧洲', '西班牙': '欧洲', '葡萄牙': '欧洲', '比利时': '欧洲', '瑞士': '欧洲', '奥地利': '欧洲', '瑞典': '欧洲', '挪威': '欧洲', '丹麦': '欧洲', '波兰': '欧洲', '俄罗斯': '欧洲', '希腊': '欧洲', '爱尔兰': '欧洲', '捷克': '欧洲', '匈牙利': '欧洲', '乌克兰': '欧洲',
  'France': '欧洲', 'United Kingdom': '欧洲', 'Germany': '欧洲', 'Italy': '欧洲', 'Finland': '欧洲', 'Netherlands': '欧洲', 'Spain': '欧洲', 'Portugal': '欧洲', 'Switzerland': '欧洲', 'Sweden': '欧洲', 'Norway': '欧洲', 'Denmark': '欧洲', 'Poland': '欧洲', 'Russia': '欧洲', 'Greece': '欧洲', 'Ireland': '欧洲',
  // 非洲
  '南非': '非洲', '埃及': '非洲', '尼日利亚': '非洲', '肯尼亚': '非洲', '摩洛哥': '非洲', '阿尔及利亚': '非洲', '突尼斯': '非洲', '埃塞俄比亚': '非洲', '加纳': '非洲', '坦桑尼亚': '非洲',
  'South Africa': '非洲', 'Egypt': '非洲', 'Nigeria': '非洲', 'Kenya': '非洲', 'Morocco': '非洲', 'Algeria': '非洲', 'Tunisia': '非洲', 'Ethiopia': '非洲', 'Ghana': '非洲', 'Tanzania': '非洲',
  // 北美洲
  '美国': '北美洲', '加拿大': '北美洲', '墨西哥': '北美洲', '古巴': '北美洲', '巴拿马': '北美洲',
  'United States': '北美洲', 'Canada': '北美洲', 'Mexico': '北美洲', 'Cuba': '北美洲', 'Panama': '北美洲',
  // 南美洲
  '巴西': '南美洲', '阿根廷': '南美洲', '智利': '南美洲', '哥伦比亚': '南美洲', '秘鲁': '南美洲', '委内瑞拉': '南美洲', '乌拉圭': '南美洲', '厄瓜多尔': '南美洲',
  'Brazil': '南美洲', 'Argentina': '南美洲', 'Chile': '南美洲', 'Colombia': '南美洲', 'Peru': '南美洲', 'Venezuela': '南美洲', 'Uruguay': '南美洲', 'Ecuador': '南美洲'
}

export default {
  name: 'city',
  props: {
    type: {
      type: Number,
      default: 1,
    },
    id: {
      id: [Number, String],
      default: 0,
    },
    selectArr: {
      type: Array,
      default: () => [],
    },
    otherSelectedArr: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      iSselect: false,
      addressModal: false,
      loading: false,
      treeData: [],       // 按洲分组的树
      countryNodes: [],   // 平铺的国家节点（用于勾选/全选/确认逻辑）
      checkedKeys: [],
      halfCheckedKeys: [],
      expandedKeys: [],
      searchValue: '',
      totalNum: 0 // 存储所有的市的个数
    };
  },
  computed: {
    ...mapGetters(['acityList']),
    // 根据搜索关键字过滤树，保留命中节点的祖先链
    filteredTreeData() {
      if (!this.searchValue) return this.treeData
      const kw = this.searchValue.trim().toLowerCase()
      const loop = (nodes) => {
        const res = []
        nodes.forEach((n) => {
          const children = n.children ? loop(n.children) : []
          const match = (n.areaName || n.title || '').toLowerCase().includes(kw)
          if (match || children.length) {
            res.push(Object.assign({}, n, {
              children: children.length ? children : (n.children || [])
            }))
          }
        })
        return res
      }
      return loop(this.treeData)
    }
  },
  watch: {
    addressModal(newVal) {
      if (newVal) {
        this.searchValue = ''
        this.expandedKeys = []
        this.countryNodes = this.buildCountryNodes(this.acityList, this.otherSelectedArr)
        // 回显已选中的地区
        const keys = []
        this.selectArr.forEach((s) => {
          const prov = this.countryNodes.find((p) => p.areaId === s.areaId)
          if (!prov || prov.disabled) return
          if (!s.cityIds) {
            // 整省(国)选中
            keys.push(prov.key)
            prov.children.forEach((c) => { if (!c.disabled) keys.push(c.key) })
          } else {
            // 部分城市选中
            const cityIdArr = String(s.cityIds).split(',')
            prov.children.forEach((c) => {
              if (!c.disabled && cityIdArr.includes(String(c.areaId))) keys.push(c.key)
            })
          }
        })
        this.checkedKeys = keys
        this.treeData = this.groupByContinent(this.countryNodes)
        this.updateISselect()
      }
    },
    searchValue(val) {
      if (val) {
        // 搜索时自动展开所有洲，方便查看命中项
        this.expandedKeys = this.treeData.map((c) => c.key)
      } else {
        this.expandedKeys = []
      }
    }
  },
  methods: {
    getContinent(node) {
      return COUNTRY_CONTINENT[node.fullName] ||
        COUNTRY_CONTINENT[node.areaName] ||
        '其它'
    },
    // 递归构建国家/地区节点，并递归按名称字母排序
    buildNode(area, disabled) {
      const children = (area.children || []).map((c) => this.buildNode(c, disabled))
      children.sort((a, b) => (a.areaName || '').localeCompare(b.areaName || ''))
      return {
        title: area.areaName,
        key: (area.children && area.children.length ? 'p_' : 'c_') + area.areaId,
        areaId: area.areaId,
        areaName: area.areaName,
        fullName: area.fullName,
        disabled,
        children
      }
    },
    buildCountryNodes(list, otherArr) {
      const otherIds = (otherArr || []).map((o) => o.areaId)
      const nodes = (list || []).map((prov) => this.buildNode(prov, otherIds.includes(prov.areaId)))
      // 洲内国家按名称字母排序
      nodes.sort((a, b) => (a.areaName || '').localeCompare(b.areaName || ''))
      return nodes
    },
    // 将国家节点按洲分组
    groupByContinent(countryNodes) {
      const groups = {}
      CONTINENT_ORDER.forEach((c) => { groups[c] = [] })
      countryNodes.forEach((node) => {
        const cont = this.getContinent(node)
        groups[cont].push(node)
      })
      const tree = []
      CONTINENT_ORDER.forEach((cont) => {
        const children = groups[cont]
        if (!children.length) return
        tree.push({
          title: cont,
          key: 'continent_' + cont,
          areaId: null,
          disabled: children.every((c) => c.disabled),
          children
        })
      })
      return tree
    },
    // 收集某节点下所有已勾选的非禁用子孙
    collectCheckedChildren(node, checkedSet, acc) {
      (node.children || []).forEach((c) => {
        if (c.disabled) return
        if (checkedSet.has(c.key)) acc.push(c)
        this.collectCheckedChildren(c, checkedSet, acc)
      })
    },
    updateISselect() {
      const checkedSet = new Set(this.checkedKeys)
      const selectableProvs = this.countryNodes.filter((p) => !p.disabled)
      const allFull = selectableProvs.length > 0 &&
        selectableProvs.every((p) => checkedSet.has(p.key))
      this.iSselect = allFull && this.otherSelectedArr.length === 0
    },
    onCheck(checkedKeys, info) {
      this.checkedKeys = checkedKeys
      this.halfCheckedKeys = info.halfCheckedKeys || []
      this.updateISselect()
    },
    onExpand(keys) {
      this.expandedKeys = keys
    },
    /**
     * 全选或者反选
     */
    allCheckbox() {
      const keys = []
      const collect = (nodes) => {
        nodes.forEach((n) => {
          if (!n.disabled) {
            keys.push(n.key)
            if (n.children) collect(n.children)
          }
        })
      }
      collect(this.countryNodes)
      this.checkedKeys = keys
      this.iSselect = this.otherSelectedArr.length === 0
    },
    // 清空
    empty() {
      this.checkedKeys = []
      this.halfCheckedKeys = []
      this.iSselect = false
    },
    /**
     * 确定选中的城市
     */
    confirm() {
      const checkedSet = new Set(this.checkedKeys)
      const selectList = []
      this.countryNodes.forEach((prov) => {
        if (prov.disabled) return
        // 整国/整地区被勾选（含无省市级下级的国家），优先按整区处理
        if (checkedSet.has(prov.key)) {
          selectList.push({ areaName: prov.areaName, areaId: prov.areaId })
          return
        }
        // 部分勾选：收集勾选的下级地区
        const cities = []
        this.collectCheckedChildren(prov, checkedSet, cities)
        if (cities.length === 0) return
        selectList.push({
          areaName: prov.areaName,
          areaId: prov.areaId,
          cityIds: cities.map((c) => c.areaId).join(','),
          cityNames: cities.map((c) => c.areaName).join(',')
        })
      })
      if (selectList.length === 0) {
        return this.$message.error('Please select at least one province or city')
      }
      const allFull = this.countryNodes
        .filter((p) => !p.disabled)
        .every((p) => checkedSet.has(p.key))
      const isAllSelect = this.otherSelectedArr.length === 0 && allFull
      this.$emit('selectCity', {
        id: this.id,
        selectList: selectList,
        type: this.type, // 0添加 1编辑
        isEdit: this.selectArr.length ? true : false,
        iSselect: isAllSelect
      })
      this.close()
    },
    close() {
      this.addressModal = false
      this.treeData = []
      this.countryNodes = []
      this.checkedKeys = []
      this.halfCheckedKeys = []
      this.searchValue = ''
      this.expandedKeys = []
    }
  }
};
</script>

<style scoped lang="less">
.modal .area-tree {
  max-height: 55vh;
  overflow: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 8px;
}

.empty {
  cursor: pointer;
}
</style>
